import { useEffect, useState } from 'react';
import { Badge, Button, Popover, List, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useTranslateJobsStore } from '@/stores/translateJobsStore';

const { Text } = Typography;

function useNowTick(intervalMs: number) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

export function BackgroundJobsBadge() {
  const jobs = useTranslateJobsStore((s) => s.jobs);
  const now = useNowTick(1000);
  if (jobs.length === 0) return null;
  return (
    <Popover
      title="Background translations"
      content={
        <List
          size="small"
          dataSource={jobs}
          renderItem={(j) => (
            <List.Item>
              <Text code style={{ fontSize: 11 }}>
                {j.jobId.slice(0, 8)}
              </Text>
              <Text type="secondary" style={{ marginLeft: 8, fontSize: 11 }}>
                {Math.round((now - j.startedAt) / 1000)}s
              </Text>
            </List.Item>
          )}
        />
      }
    >
      <Badge count={jobs.length} offset={[-4, 4]}>
        <Button icon={<ClockCircleOutlined />} />
      </Badge>
    </Popover>
  );
}
